import get from 'lodash/get'
import React from 'react'
import { TableProps } from './interface'
import { TableBox, TableTag, TBody, TD, TH } from './style'

class Table<T> extends React.Component<TableProps<T>> {
  render() {
    const { columns, dataSource, basic } = this.props

    return (
      <TableBox>
        <TableTag>
          <thead>
            <tr>
              {columns.map(({ key, title, width, align }) => (
                <TH key={key} width={width} textAlign={align} basic>
                  {title}
                </TH>
              ))}
            </tr>
          </thead>
          <TBody basic={basic}>
            {dataSource.map((data: any, index: number) => (
              <tr key={`tbody-tr-${index}`}>
                {columns.map(({ key, align, dataIndex, render }) => {
                  const text = get(data, dataIndex)
                  return (
                    <TD key={key} textAlign={align} basic>
                      {render ? render(text, data, index) : text}
                    </TD>
                  )
                })}
              </tr>
            ))}
          </TBody>
        </TableTag>
      </TableBox>
    )
  }
}

export default Table
